import { reportDate } from '../../reportClock';
import { firebase_app } from '../../../../Config/Config';
import { getFunctionUrl } from '../../../../utils/apiHost';

export const PERIOD_PRESETS = {
  today: { label: 'Aujourd’hui', days: 0 },
  yesterday: { label: 'Hier', days: 0, offset: -1 },
  thisWeek: { label: 'Cette semaine', kind: 'week' },
  previousWeek: { label: 'Semaine précédente', kind: 'previousWeek' },
  thisMonth: { label: 'Ce mois', kind: 'month' },
  previousMonth: { label: 'Mois précédent', kind: 'previousMonth' },
  thisQuarter: { label: 'Ce trimestre', kind: 'quarter' },
  previousQuarter: { label: 'Trimestre précédent', kind: 'previousQuarter' },
  thisYear: { label: 'Cette année', kind: 'year' },
  previousYear: { label: 'Année précédente', kind: 'previousYear' },
  custom: { label: 'Période personnalisée', kind: 'custom' },
};

export const toDateInput = (date) => {
  const adjusted = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return adjusted.toISOString().slice(0, 10);
};

export const resolvePreset = (preset, now = new Date()) => {
  const start = new Date(`${reportDate(now)}T12:00:00`);
  const end = new Date(start);
  const config = PERIOD_PRESETS[preset] || PERIOD_PRESETS.thisMonth;

  if (config.offset) {
    start.setDate(start.getDate() + config.offset);
    end.setDate(end.getDate() + config.offset);
  } else if (config.kind === 'week') {
    start.setDate(start.getDate() - start.getDay());
  } else if (config.kind === 'previousWeek') {
    start.setDate(start.getDate() - start.getDay() - 7);
    end.setTime(start.getTime());
    end.setDate(end.getDate() + 6);
  } else if (config.kind === 'month') {
    start.setDate(1);
  } else if (config.kind === 'previousMonth') {
    start.setMonth(start.getMonth() - 1, 1);
    end.setDate(0);
  } else if (config.kind === 'quarter') {
    start.setMonth(Math.floor(start.getMonth() / 3) * 3, 1);
  } else if (config.kind === 'previousQuarter') {
    start.setMonth(Math.floor(start.getMonth() / 3) * 3 - 3, 1);
    end.setTime(start.getTime());
    end.setMonth(end.getMonth() + 3, 0);
  } else if (config.kind === 'year') {
    start.setMonth(0, 1);
  } else if (config.kind === 'previousYear') {
    start.setFullYear(start.getFullYear() - 1, 0, 1);
    end.setFullYear(end.getFullYear() - 1, 11, 31);
  }

  return { startDate: toDateInput(start), endDate: toDateInput(end) };
};

export const initialFilters = (params, now = new Date()) => {
  const preset = params.get('period') || 'today';
  const presetDates = resolvePreset(preset, now);
  return {
    period: preset,
    startDate: preset === 'custom' ? (params.get('startDate') || presetDates.startDate) : presetDates.startDate,
    endDate: preset === 'custom' ? (params.get('endDate') || presetDates.endDate) : presetDates.endDate,
    agentIds: params.get('agentIds') || '',
    comparisonMode: params.get('comparisonMode') || 'previous',
    status: params.get('status') || 'active',
    metric: params.get('metric') || 'noticesIssued',
    search: params.get('search') || '',
    page: Number(params.get('page') || 1),
    pageSize: Number(params.get('pageSize') || 25),
    sortBy: params.get('sortBy') || 'score',
    sortDirection: params.get('sortDirection') || 'desc',
  };
};

export const filtersToParams = (filters) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== '' && value !== null && value !== undefined) params.set(key, String(value));
  });
  return params;
};

const getToken = async () => {
  const user = firebase_app.auth().currentUser;
  if (!user) throw new Error('Votre session a expiré. Veuillez vous reconnecter.');
  return user.getIdToken();
};

export const loadPerformanceReport = async (filters, options = {}) => {
  const token = await getToken();
  const params = filtersToParams({ ...filters, resource: options.resource || 'summary' });
  const response = await fetch(`${getFunctionUrl('/api/employee-performance')}?${params}`, {
    headers: { Accept: options.resource === 'export' ? 'text/csv' : 'application/json', Authorization: `Bearer ${token}` },
    signal: options.signal,
    cache: 'no-store',
  });
  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload.message || 'Impossible de charger le rapport.');
  }
  return options.resource === 'export' ? response.blob() : response.json();
};

export const downloadCsv = async (filters) => {
  const blob = await loadPerformanceReport(filters, { resource: 'export' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `performance-employes-${filters.startDate}-${filters.endDate}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

export const formatValue = (value, suffix = '') =>
  value === null || value === undefined ? 'Donnée non disponible' : `${new Intl.NumberFormat('fr-CA', { maximumFractionDigits: 2 }).format(value)}${suffix}`;
